import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WarningDialogComponent } from 'src/app/shared/dialogs/warning-dialog/warning-dialog.component';
import { FileSave } from './model/file-uplaod.interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UploadFileMobileComponent } from 'src/app/shared/dialogs/upload-file-mobile/upload-file-mobile.component';
import { NameFileRegex } from 'src/app/core/model/constans';
import { FilePresignUrlUploadService } from './service/file-upload-component.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-file-upload-component',
  templateUrl: './file-upload-component.component.html',
  styleUrls: ['./file-upload-component.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileUploadComponentComponent,
      multi: true,
    },
  ],
})
export class FileUploadComponentComponent implements OnInit, ControlValueAccessor {
  @Input()
  labelText: string;

  @Input()
  oneFile: boolean;

  @Input()
  extensions: string[];

  @Input()
  isImg: boolean;

  @Input()
  maxSizeFile: number;

  @Input()
  documentId: number;

  @Input()
  ocrValidation: boolean;

  @Input()
  submitted: boolean;

  @Input()
  required: boolean;

  @Input()
  id: string;

  @Input()
  subtitle: string;

  imageSrc: string;
  fileName: string;
  fileNameWithoutTime: string;
  extensionsText: string;
  fileModel: any;
  isMobile: boolean;
  filesImg: FileSave[] = [];
  useCamera: boolean = false;
  presignUrl: string = '';

  onChange: (value: any) => void = () => {
    // Implementación de la función onChange
  };

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef = {} as ElementRef;

  constructor(
    public dialog: MatDialog,
    private readonly cd: ChangeDetectorRef,
    private readonly servicePresignUrl: FilePresignUrlUploadService,
    private readonly deviceService: DeviceDetectorService,
    private readonly spinner: NgxSpinnerService,
  ) {
    this.isImg = false;
    this.oneFile = false;
    this.labelText = '';
    this.extensions = [];
    this.submitted = false;
    this.required = false;
    this.maxSizeFile = 0;
    this.documentId = 0;
    this.id = '';
    this.fileName = '';
    this.fileNameWithoutTime = '';
    this.extensionsText = '';
    this.imageSrc = '';
    this.ocrValidation = false;
    this.isMobile = this.deviceService.isMobile();
    this.subtitle = '';
  }

  esIphone(): boolean {
    return this.deviceService.os === 'iOS' && /iPhone/i.test(navigator.userAgent);
  }

  writeValue(obj: any): void {
    if (obj?.length > 0) {
      for (let file of obj) {
        this.filesImg.push(file);
      }
      this.cd.detectChanges();
    } else {
      this.filesImg = [];
      this.cd.detectChanges();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit(): void {
    this.extensionsText = this.extensions.join(' - ');
  }

  onFileDropped(event: any[]) {
    if (event) {
      let file: File = event[0];
      if (file) {
        this.fileNameWithoutTime = file.name;
        this.fileName = this.servicePresignUrl.createFilename(file);
        this.servicePresignUrl.getPresignUrlUpload(this.fileName, file.type).subscribe((res) => {
          this.presignUrl = res;
          this.readFile(file);
        });
      }
    }
  }

  async checkCameraPermission() {
    try {
      const permissionStatus = await navigator.permissions.query({ name: 'camera' as PermissionName });
      if (permissionStatus.state === 'granted') {
        this.clickInput();
      } else if (permissionStatus.state === 'prompt') {
        this.clickInput();
      } else if (permissionStatus.state === 'denied') {
        this.showWarning(
          'Permisos denegados. Por favor, habilita los permisos para la cámara en la configuración de tu dispositivo.'
        );
      }
    } catch (error) {
      console.error('Error al verificar permisos:', error);
      this.clickInput(); // En caso de error, intentamos abrir la cámara directamente
    }
  }

  mobileDialogUpload() {
    let dialogRef = this.dialog.open(UploadFileMobileComponent, {
      width: '80%',
      height: '20%',
    });
    dialogRef.afterClosed().subscribe((openGalery) => {
      if (openGalery) {
        this.useCamera = false;
        this.cd.detectChanges();
        this.clickInput();
      } else if(openGalery === false) {
        this.useCamera = true;
        this.cd.detectChanges();
        if (this.deviceService.os === 'Android') {
          this.clickInput();
        } else {
          this.checkCameraPermission();
        }
      }
    });
  }

  clearFileInput() {
    this.fileInput.nativeElement.value = null;
  }

  async uploadFile(file: File, isOcr: boolean) {
    try {
      this.spinner.show().catch();
      await this.servicePresignUrl.uploadToPresignedUrl(this.presignUrl, file);
      this.spinner.hide().catch();
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async (e) => {
        this.imageSrc = reader.result as string;
        const img: {
          src: string;
          name: string;
          type: string;
          id: number;
          file?: File;
        } = {
          src: this.imageSrc,
          name: this.fileName,
          type: file.type,
          id: this.documentId,
        };
        if (isOcr) img.file = file;
        this.filesImg.push(img);
        this.onChange(this.filesImg);
      };
    } catch (error) {
      console.error('Hubo un error al cargar el archivo en el bucket');
    }
  }

  deleteImg(id: any) {
    event?.stopPropagation();
    const filesDeleted = this.filesImg.splice(id, 1);
    this.onChange(this.filesImg);
    // Delete img del bucket fileDeleted[0] es el file
    this.servicePresignUrl.deleteFileBucket(filesDeleted[0].name).subscribe((deleted) => {
      if (deleted) console.log('Archivo eliminado');
      else console.error('No se pude eliminar el archivo');
    });
  }

  async onFileSelected(event: any) {
    if (event?.target?.files) {
      let file: File = event.target.files[0];
      if (this.validateFile(file)) {
        this.fileNameWithoutTime = file.name;
        this.fileName = this.servicePresignUrl.createFilename(file);
        this.servicePresignUrl.getPresignUrlUpload(this.fileName, file.type).subscribe((res) => {
          this.presignUrl = res;
          this.readFile(file);
        });
      }
      this.clearFileInput();
    }
  }

  readFile(file: File) {
    document.getElementById('id')?.remove();
    if (this.ocrValidation) {
      this.uploadFile(file, true);
    } else {
      this.uploadFile(file, false);
    }
  }

  clickInput() {
    let input = document.getElementById(this.id);
    if (input) {
      console.log('input click');
      console.log(input);
      input.click();
      input.onerror = (error) => {
        console.error('Error al acceder a la galería:', error);
        this.showWarning('No se pudo acceder a la galería. Por favor, verifica los permisos.');
      };
    }
  }

  openFileDialog() {
    if (this.isMobile && !this.esIphone()) {
      this.mobileDialogUpload();
    } else {
      this.clickInput();
    }
  }

  openFileDialogOnKeyDown(event: KeyboardEvent) {
    this.openFileDialog();
  }

  validateFile(file: File): boolean {
    const isImage = file.type.startsWith('image/');
    if (!this.validateExtension(file)) {
      this.showWarning('El archivo tiene una extensión no válida');
      return false;
    }

    if (!this.validateFileSize(file)) {
      this.showWarning(`El archivo debe pesar menos de ${this.maxSizeFile}MB`);
      return false;
    }

    if (!this.validateName(file)) {
      this.showWarning(`El nombre del archivo no es valido`);
      return false;
    }

    return true;
  }

  validateExtension(file: File): boolean {
    return this.extensions.some((s) => {
      return file.type.includes(s.replace('.', ''));
    });
  }

  validateName(file: File): boolean {
    return NameFileRegex.test(file.name);
  }

  validateFileSize(file: File): boolean {
    const fileSize = this.maxSizeFile - 0.2;
    return file.size / 1024 / 1024 < fileSize;
  }

  showWarning(message: string) {
    this.dialog.open(WarningDialogComponent, {
      data: {
        title: 'No se pudo adjuntar el archivo',
        message,
      },
    });
  }

  validateWarning() {
    if (this.required && this.submitted && this.filesImg.length == 0) {
      return true;
    }
    return false;
  }
}
